import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button'
import { drawerTransition, DRAWER_WIDTH, SIDEBAR_PADDING } from './styles';

const DrawerButton = styled(Button, { shouldForwardProp: prop => prop !== 'open' })<ButtonProps & { open: boolean }>(({ theme, open }) => ({
  width: open ? DRAWER_WIDTH - SIDEBAR_PADDING * 2 : 48,
  marginLeft: open ? 0 : '-9px',
  display: 'flex',
  justifyContent: 'space-between',
  transition: drawerTransition(theme, ['margin', 'width', 'padding']),
  minWidth: 0,
  '& .MuiButton-endIcon': {
    fontSize: 24,
    marginLeft: '-12px',
    '& .MuiSvgIcon-root': {
      fontSize: 24,
    }
  },
}))

export default DrawerButton
